module.exports = __webpack_public_path__ + "static/media/icon-call-svg.abce0935.svg";